import React from 'react';
import {
  shape, bool, number
} from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import {
  formatInventory, showBopisDate
} from '../../../helper/utils';

const DefaultBOPIS = ({ localStoreLocation }) => {
  const { storeHours } = useStore();
  const isInStock = localStoreLocation?.inventory?.isInStock || '';
  const quantity = localStoreLocation?.inventory?.quantity;
  const formattedInventoryQty = formatInventory(quantity);

  return (
    <div className="fulfillment-tile">
      <TileHead title="Pickup" />
      <div className="fulfillment__sub-title">
        {isInStock && (
          <>
            <div className="u__bold">{showBopisDate(storeHours)}</div>
            <div className="fulfillment-qty-row">
              <span className="u__text--success">{formattedInventoryQty}</span> in stock
            </div>
          </>
        )}
      </div>
      <TileFooter className="u__bold">
        <span className="u__text--success">FREE</span>
      </TileFooter>
    </div>
  );
};

DefaultBOPIS.propTypes = {
  localStoreLocation: shape({
    isAnchor: bool,
    inventory: shape({
      quantity: number,
      isInStock: bool,
      isLimitedQuantity: bool,
      isBackordered: bool
    })
  }).isRequired
};

DefaultBOPIS.defaultProps = {};

export { DefaultBOPIS };
